var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Label } from 'semantic-ui-react';
import styled from 'styled-components';
var StyledColumn = styled(Label.Group)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: auto;\n  display: inline-flex;\n  flex-direction: row;\n  justify-content: flex-end;"], ["\n  width: auto;\n  display: inline-flex;\n  flex-direction: row;\n  justify-content: flex-end;"])));
Object.assign(StyledColumn, {
    displayName: 'LabelGroup',
});
export default StyledColumn;
var templateObject_1;
//# sourceMappingURL=group.js.map